import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
  type: Yup.string().required("A type must be selected"),
});
